module.exports = __webpack_public_path__ + "static/media/visual-merchandising-banner.6873714c.png";